import { useEffect, useRef } from 'react';

const CHANNEL_NAME = 'nareea-calendar-sync';

export function useCalendarSync(onMessage) {
  const channelRef = useRef(null);

  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channelRef.current = channel;
    if (onMessage) {
      channel.onmessage = (e) => onMessage(e.data);
    }
    return () => channel.close();
  }, []);

  const broadcast = (type, payload) => {
    if (channelRef.current) {
      channelRef.current.postMessage({ type, payload, ts: Date.now() });
    }
  };

  return { broadcast };
}

export function openInWindow(panelId) {
  const url = `${window.location.origin}?panel=${panelId}`;
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
